import React from 'react';
import PropTypes from 'prop-types';
import {
  ItemPillActions,
  ItemPillActionIcon,
} from 'Components/Base/ItemPill';

const VideoListItem = ({
  video,
  isProcessing,
  onEdit,
  onRemove,
}) => {
  const isLibraryVideo = video.libraryVideoId !== null;

  return (
    <li className="video-list__item">
      {isLibraryVideo ? (
        <a
          href={`/admin/library_videos/${video.libraryVideo?.uuid}`}
          className="video-list__name"
        >
          {video.name}
        </a>
      ) : (
        <span
          className="video-list__name video-list__name--clickable"
          onClick={() => onEdit(video)}
        >
          {video.name}
        </span>
      )}
      <ItemPillActions isLoading={isProcessing}>
        {!isLibraryVideo && (
          <ItemPillActionIcon
            iconName="file-edit-blue"
            data-test="edit-icon"
            onClick={() => onEdit(video)}
          />
        )}
        <ItemPillActionIcon
          iconName="minus-circle-blue"
          data-test="delete-icon"
          onClick={() => onRemove(video)}
        />
      </ItemPillActions>
    </li>
  );
};

VideoListItem.propTypes = {
  video: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    libraryVideoId: PropTypes.number,
    libraryVideo: PropTypes.shape({
      uuid: PropTypes.string,
    }),
  }).isRequired,
  isProcessing: PropTypes.bool,
  onEdit: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
};

VideoListItem.defaultProps = {
  isProcessing: false,
};

export default VideoListItem;
